var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidityCheckMeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0397 4C9.08309 4 8.33527 4.70711 7.65833 5.60539C6.72809 4.44294 5.95012 4 5.01911 4C3.12099 4 1.66667 6.42429 1.66667 8.99025C1.66667 10.5959 2.4582 11.6087 3.78399 11.6087C4.73822 11.6087 5.4245 11.1672 6.64451 9.07422C6.64451 9.07422 7.15308 8.19281 7.50294 7.58566C7.6341 7.79377 7.76323 8.00311 7.89031 8.21363L8.46241 9.15817C9.57688 10.9884 10.1978 11.6087 11.3229 11.6087C12.6145 11.6087 13.3333 10.5821 13.3333 8.94304C13.3333 6.25637 11.8462 4 10.0397 4ZM5.71418 8.5075C4.72502 10.0292 4.38284 10.3703 3.83211 10.3703C3.26537 10.3703 2.92852 9.88199 2.92852 9.01125C2.92852 7.14842 3.87488 5.24362 5.00306 5.24362C5.61399 5.24362 6.12452 5.58989 6.90655 6.68862C6.16399 7.80643 5.71418 8.5075 5.71418 8.5075ZM9.44738 8.31592L8.76335 7.19632C8.57824 6.90087 8.40034 6.62889 8.22965 6.38044C8.84616 5.44659 9.35471 4.98126 9.95953 4.98126C11.216 4.98126 12.2212 6.79686 12.2212 9.02699C12.2212 9.87707 11.9375 10.3703 11.3497 10.3703C10.7863 10.3703 10.5171 10.0051 9.44738 8.31592Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidityCheckMeta);
export default __webpack_public_path__ + "static/media/validity-check-meta.c04b6ed127d559a9e1a96ca16f04ac7a.svg";
export { ForwardRef as ReactComponent };